import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type IssuedCertificateEvent_ExternalEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEvent_LiveEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEvent_OfflineEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEvent_RecurringExternalEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEvent_RecurringLiveEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEvent_RecurringOfflineEventType_Fragment = { id: string, type: Types.EventTypeEnum };

export type IssuedCertificateEventFragment = IssuedCertificateEvent_ExternalEventType_Fragment | IssuedCertificateEvent_LiveEventType_Fragment | IssuedCertificateEvent_OfflineEventType_Fragment | IssuedCertificateEvent_RecurringExternalEventType_Fragment | IssuedCertificateEvent_RecurringLiveEventType_Fragment | IssuedCertificateEvent_RecurringOfflineEventType_Fragment;


export type IssuedCertificateEventFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IssuedCertificateEventFragmentDoc = /*#__PURE__*/ gql`
    fragment IssuedCertificateEvent on EventUnion {
  ... on LiveEventType {
    id
    type
  }
  ... on OfflineEventType {
    id
    type
  }
  ... on ExternalEventType {
    id
    type
  }
  ... on RecurringExternalEventType {
    id
    type
  }
  ... on RecurringLiveEventType {
    id
    type
  }
  ... on RecurringOfflineEventType {
    id
    type
  }
}
    `;